// @ts-nocheck
import type { IOptionProps } from './token'

export function useOption(props: IOptionProps, { emit }) {
  return {
    hoverItem: () => {
      if (!props.disabled) {
        emit('hover', props.index)
      }
    },
    selectOptionClick: () => {
      if (!props.disabled) {
        emit('select', props.item, props.index)
      }
    },
  }
}
